// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__6ujvS","link":"styles_link__oRbVD","slideInSearchBar":"styles_slideInSearchBar__cflMf"};